"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AddToCartMutation = (0, graphql_tag_1.default) `
  mutation cartMutation(
    $id: String
    $productId: String!
    $sellerId: String!
    $extensions: DataValue
    $quantity: String!
    $services: [String]
    $partnerId: String
    $customerId: String
  ) {
    addToCart(
      cartRequest: {
        id: $id
        productId: $productId
        sellerId: $sellerId
        extensions: $extensions
        quantity: $quantity
        services: $services
        partnerId: $partnerId
        customerId: $customerId
      }
    ) {
      id
      status
    }
  }
`;
exports.default = AddToCartMutation;
